export enum remoteDeviceDeviceGroup {
    ATM = 1,
    PED = 2,
    POS = 3,
    CellPhone = 4,
    miniATM = 5,
    SMSPrinter = 6,
}

export namespace remoteDeviceDeviceGroup {
    export function values() {
        return Object.keys(remoteDeviceDeviceGroup).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}